module.exports = __webpack_public_path__ + "rex.png?52be4a693d702c633ec6369e283f9951";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rex.png
// module id = 45
// module chunks = 0